import React, {Component} from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import {Spinner} from 'react-bootstrap';
import BreadcrumbCustomer from "../../Layout/user/BreadcrumbCustomer";
import {FaCloud} from "react-icons/fa";
import { Card, CardBody } from 'reactstrap';

class ChangeUserByVpsComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            btnSubmit: true,
            loadPage: true,
            isLoading: true,
            listService: [],
            error: false,
            messageError: '',
            email: '',
            checkEmail: false,
            userChange: {},
            errorForm: false,
            messageForm: '',
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getDetailListVps( this.props.listVpsId );
    }

    getDetailListVps = (listVpsId) => {
        this.setState({
            loadPage: true,
        });
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        axios.get( process.env.REACT_APP_API_URL + '/api/vps/getDetailListVps?listVpsId=' + listVpsId,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listService: ref.data.content,
                        loadPage: false,
                        error: false,
                        messageError: '',
                    })
                } else {
                    if ( ref.data.error > 9000 ) {
                        this.props.logOut();
                    }
                    else if ( ref.data.error > 8000 ) {
                        this.redirectBack(ref.data.message);
                    }
                    else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( () => {
                this.setState({
                    loadPage: false,
                    error: true,
                    messageError: 'Lấy dữ liệu VPS thất bại',
                })
            })
    }

    btnRedirectBack = () => {
        this.props.redirectBack();
    }

    redirectBack = (message) => {
        this.props.updateErrorNotiUser({
            error: true,
            message: message
        });
        this.props.redirectBack();
    }

    redirectSuccess = (message) => {
        this.props.updateSuccessNotiUser({
            success: true,
            message: message
        });
        this.props.redirectBack();
    }

    changeInput = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    checkEmail = () => {
        if ( this.state.email.length ) {
            this.setState({
                loadPage: true,
            });
            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };
            axios.get( process.env.REACT_APP_API_URL + '/api/vps/checkEmailByCustomer/' + this.state.email,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization' : this.props.token,
                        'dataAgency' : JSON.stringify(dataAuth)
                    }
                }
            )
                .then( (ref) => {
                    // console.log(ref.data);
                    if ( ref.data.error === 0 ) {
                        this.setState({
                            loadPage: false,
                            errorForm: false,
                            btnSubmit: false,
                            messageForm: '',
                            userChange: ref.data.content,
                            checkEmail: true
                        })
                    } else {
                        if ( ref.data.error > 9000 ) {
                            this.props.logOut();
                        }
                        else {
                            this.setState({
                                btnSubmit: true,
                                errorForm: true,
                                messageForm: ref.data.message,
                                loadPage: false,
                                checkEmail: false,
                            })
                        }
                    }
                    // console.log(this.state.perPage);
                })
                .catch( () => {
                    this.setState({
                        loadPage: false,
                        checkEmail: false,
                        errorForm: true,
                        btnSubmit: true,
                        messageForm: 'Lấy dữ liệu thất bại',
                    })
                })

        } else {
            this.setState({
                errorForm: true,
                messageForm: 'Email không được để trống',
            })
        }
    }

    submit = () => {
        if ( this.state.checkEmail ) {
            this.setState({
                loadPage: true,
                btnSubmit: true,
            });
            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };
            let form = {
                listVpsIp: this.props.listVpsId,
                userId: this.state.userChange.id,
            };
            // console.log(form);
            axios.put( process.env.REACT_APP_API_URL + '/api/vps/changeUserByVps', form,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization' : this.props.token,
                        'dataAgency' : JSON.stringify(dataAuth)
                    }
                }
            )
                .then( (ref) => {
                    // console.log(ref.data);
                    if ( ref.data.error === 0 ) {
                        this.setState({
                            loadPage: false,
                        })
                        this.redirectSuccess(ref.data.message);
                    } else {
                        if ( ref.data.error > 9000 ) {
                            this.props.logOut();
                        }
                        else if ( ref.data.error > 8000 ) {
                            this.redirectBack(ref.data.message);
                        }
                        else {
                            this.setState({
                                btnSubmit: false,
                                errorForm: true,
                                messageForm: ref.data.message,
                                loadPage: false,
                                checkEmail: false,
                            })
                        }
                    }
                    // console.log(this.state.perPage);
                })
                .catch( () => {
                    this.setState({
                        loadPage: false,
                        checkEmail: false,
                        errorForm: true,
                        btnSubmit: false,
                        messageForm: 'Truy vấn dữ liệu thất bại',
                    })
                })
        } else {
            alert("Quý khách vui lòng kiểm tra khách hàng muốn chuyển VPS.")
        }
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <>
                            <BreadcrumbCustomer title={"Chuyển khách hàng"} page={"VPS"} icon={<FaCloud className="breadcrumb-icon"/>}/>
                            <Card className="card-change-user">
                                <CardBody>
                                    {
                                        this.state.error ? (
                                            <Alert color="danger">
                                                { this.state.messageError }
                                            </Alert>
                                        ) : (
                                            <div className="m-4">
                                                <div className="form-group row">
                                                    <div className="col-md-12 text-center">
                                                        {
                                                            this.state.errorForm ? (
                                                                <Alert color="danger">
                                                                    { this.state.messageForm }
                                                                </Alert>
                                                            ) : (
                                                                <></>
                                                            )
                                                        }
                                                    </div>
                                                    <div className="col-md-12 mb-3">
                                                        <h5>Danh sách VPS:</h5>
                                                        <div className="col-md-3">
                                                            {
                                                                this.state.listService.map( (vps, key) => (
                                                                    <div key={key}>
                                                                        <b>{key+1}. </b> { vps.ip }
                                                                    </div>
                                                                ))
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label htmlFor="email">Email khách hàng: </label>
                                                    <div className="input-group mb-3">
                                                        <input type="email" placeholder="Nhập email của khách hàng muốn chuyển và kiểm tra"
                                                               name="email" id="email" className="form-control"
                                                               onChange={ this.changeInput }
                                                        />
                                                        <div className="input-group-append">
                                                            <button type="button" className="btn btn-outline-success"
                                                                    onClick={ () => this.checkEmail() }
                                                            >
                                                                Kiểm tra
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                {
                                                    this.state.checkEmail ? (
                                                        <div className="mt-2">
                                                            <div>
                                                                <h5>Thông tin khách hàng:</h5>
                                                            </div>
                                                            <div className="mt-1">
                                                                <div className="ml-2">
                                                                    <b>- Họ và tên:</b> {this.state.userChange.name}
                                                                </div>
                                                                <div className="ml-2">
                                                                    <b>- Email:</b> {this.state.userChange.email}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <></>
                                                    )
                                                }
                                                <div className="form-group row">
                                                    <div className="col-md-12 text-center">
                                                        <button className="btn btn-default mr-1"
                                                                onClick={ () => this.btnRedirectBack() }
                                                        >
                                                            Quay lại
                                                        </button>
                                                        <button className="btn btn-primary ml-1"
                                                                onClick={ () => this.submit() }
                                                                disabled={ this.state.btnSubmit }
                                                        >
                                                            Xác nhận
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                </CardBody>
                            </Card>
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'CustomerChangeUserVps' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
        updateSuccessNotiUser: (item) => {
            dispatch(({ type : 'updateSuccessNotiUser', item }))
        },
        updateErrorNotiUser: (item) => {
            dispatch(({ type : 'updateErrorNotiUser', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ChangeUserByVpsComponent);